import { FadeIn } from "../FadeIn";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../ui/accordion";
import { FAQ } from "../../lib/images";

export const FaqSection = () => (
  <section
    data-testid="faq-section"
    className="section-pad container-x bg-ink border-t border-white/10"
  >
    <div className="grid md:grid-cols-3 gap-12">
      <FadeIn>
        <div className="eyebrow mb-3">Questions</div>
        <h2 className="font-display text-4xl md:text-6xl">
          Avant de <span className="italic text-stone">collaborer</span>.
        </h2>
      </FadeIn>
      <div className="md:col-span-2">
        <Accordion type="single" collapsible className="w-full">
          {FAQ.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger
                data-testid={`faq-${i}`}
                className="text-left text-lg md:text-xl py-6 hover:no-underline hover:text-stone"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-bone/70 pb-6 text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
